import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Login from "../pages/Authentication/Login";
import Forgetpassword from "../pages/Authentication/Forgetpassword";
import Dashboard from "../pages/Dashboard/index";
import UserManagmentlist from "pages/UserManagement/UserManagmentlist";
import ManufacturerManagmentlist from "pages/ManufacturerManagement/ManufacturerManagmentlist";
import AdminProfileUpdate from "pages/AdminManagement/adminProfile";
import AdminSetting from "pages/AdminManagement/adminSetting";
import CreateBanner from "pages/BannerManagement/CreateBanner";
import BannerManagementlist from "pages/BannerManagement/BannerManagmentlist";
import UpdateBanner from "pages/BannerManagement/UpdateBanner";
import CategoryListManagement from "pages/CategoryManagement/CategoryListManagement";
import CreateCategory from "pages/CategoryManagement/CreateCategory";
import UpdatedCategory from "pages/CategoryManagement/UpdatedCategory";
import SubCategorylistManagement from "pages/CategoryManagement/SubCategorylistManagement";
import SubCategoryCreate from "pages/CategoryManagement/SubCategoryCreate";
import SubSubCategoryUpdate from "pages/CategoryManagement/SubCategoryUpdate";
import ChildCategoryManagement from "pages/CategoryManagement/ChildCategoryManagement";
import ChildCategoryCreate from "pages/CategoryManagement/ChildCategoryCreate";
import ChildCategoryUpdate from "pages/CategoryManagement/ChildCategoryUpdate";
import Userdetails from "pages/UserManagement/Userdetails";
import HomeBlockManagementlist from "pages/HomeBlockManagement/HomeBlockManagementlist";
import CreateHomeblock from "pages/HomeBlockManagement/CreateHomeblock";
import VideoManagementlist from "pages/VideoManagement/VideoManagementlist";
import CreateVideo from "pages/VideoManagement/CreateVideo";
import { Path } from "leaflet";
import UpdateVideo from "pages/VideoManagement/UpdateVideo";
import SizeManagement from "pages/HomeBlockManagement/SizeManagement";
import CreateSize from "pages/HomeBlockManagement/CreateSize";
import UpdateSize from "pages/HomeBlockManagement/UpdateSize";
import UpdateHomeBlock from "pages/HomeBlockManagement/UpdateHomeBlock";
import ProductManagementlist from "pages/ProductManagement/ProductManagementList";
import WebHomeBlockList from "pages/HomeBlockManagement/WebHomeblockManagement/WebHomeBlockList/WebHomeBlockList";
import AddWebHomeblock from "pages/HomeBlockManagement/WebHomeblockManagement/AddWebHomeblock/AddWebHomeblock";
import UpdateWebBlock from "pages/HomeBlockManagement/WebHomeblockManagement/UpdatedWebBlock/UpdateWebBlock";
import ProductDetails from "pages/ProductManagement/ProductDetails/ProductDetails";
import Manufacturedetails from "pages/ManufacturerManagement/Manufacturedetails";
import DeliveryAgentsManagementlist from "pages/DeliveryAgentsManagement/DeliveryAgentsManagementlist";
import DeliveryAgentsDetails from "pages/DeliveryAgentsManagement/DeliveryAgentsDetails";
import Shopdetails from "pages/UserManagement/Shopdetails";
import UserOrderDetails from "pages/UserManagement/UserOrderDetails";
import SearchHomeBlockList from "pages/HomeBlockManagement/SearchHomeBlock/SearchHomeBlockList";
import CreateSearchBlock from "pages/HomeBlockManagement/SearchHomeBlock/CreateSearchBlock";
import UpdateSeachBlock from "pages/HomeBlockManagement/SearchHomeBlock/UpdateSeachBlock";
import SupportManagement from "pages/SupportManagement/SupportManagement";
import OrderManagementList from "pages/OrderManagement/OrderManagementList";
import UserManageOrderDetails from "pages/OrderManagement/UserManageOrderDetails";
import WarehouseManagementList from "pages/WarehouseManagement/WarehouseManagementList";
import WareHouseInventoryManage from "pages/WarehouseManagement/WareHouseInventoryManage";
import OrderSentManufacturer from "pages/OrderManagement/OrderSentManufacturer";
import SupportTicketReplay from "pages/SupportManagement/SupportTicketReplay";
import SupportListCategory from "pages/SupportManagement/CategoryManagement/SupportListCategory";
import SupportCategoryUpdate from "pages/SupportManagement/CategoryManagement/SupportCategoryUpdate";
import SupportCreateCategory from "pages/SupportManagement/CategoryManagement/SupportCreateCategory";
import FaqManagement from "pages/FAQManagement/FaqManagement";
import FaqCreate from "pages/FAQManagement/FaqCreate";
import FaqUpdate from "pages/FAQManagement/FaqUpdate";
import RoleManagement from "pages/RoleManagement/RoleManagement";
import RoleCreate from "pages/RoleManagement/RoleCreate";
import RoleUpdate from "pages/RoleManagement/RoleUpdate";
import NewsLetterList from "pages/NewsLetterManagement/NewsLetterList";
import SettingManage from "pages/SettingMangement/SettingManage";
import NotificationManagement from "pages/NotificationManagement/NotificationManagement";
import NotificationCreate from "pages/NotificationManagement/NotificationCreate";
import NotificationUpdate from "pages/NotificationManagement/NotificationUpdate";
import ShopList from "pages/ShopManagemnet/ShopList";
import AdminWalletTransactions from "pages/TransactionsOverview/AdminWalletTransactions";
import ManufacturerWalletTransactions from "pages/TransactionsOverview/ManufacturerWalletTransactions";
import AgentWalletTransactions from "pages/TransactionsOverview/AgentWalletTransactions";
import WithdrawalRequest from "pages/TransactionsOverview/WithdrawalRequest";
import InstructionsSetting from "pages/SettingMangement/InstructionsSetting";
import AssignOrderList from "pages/OrderManagement/AssignOrderList";
import InquiryList from "pages/InquiryMangement/InquiryList";
import InquiryReplyViewMode from "pages/InquiryMangement/InquiryReplyViewMode";
import CartManagement from "pages/CartManagement/CartManagement";
import ManufacturerOrderDetails from "pages/OrderManagement/ManufacturerOrderDetails";
import UserTransactions from "pages/TransactionsOverview/UserTransactions";
import ManufacturerTransactions from "pages/TransactionsOverview/ManufacturerTransactions";
import ConfirmOrderAssign from "pages/OrderManagement/ConfirmOrderAssign";
import ManufaturerConfirmOrderAssign from "pages/OrderManagement/ManufaturerConfirmOrderAssign";
import WarehouseManagementCreate from "pages/WarehouseManagement/WarehouseManagementCreate";
import WarehouseManagementUpdate from "pages/WarehouseManagement/WarehouseManagementUpdate";
import NotificationsDetails from "pages/NotificationsDetails/NotificationsDetails";



const userRoutes = [
  // Dashboard
  { path: "/dashboard", component: Dashboard, title: "Dashboard" },
  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },

  { path: "/users", component: UserManagmentlist, title: "User Management" },
  { path: "/userdetails/:id", component: Userdetails, title: "User Management" },

  //Manufacturer route
  { path: "/manufacturers", component: ManufacturerManagmentlist, title: "User Management" },
  { path: "/manufacturers-details/:id", component: Manufacturedetails, title: "User Management" },

  //Manufacturer route
  { path: "/manufacturers", component: ManufacturerManagmentlist, title: "User Management" },

  //  Delivery Agents
  { path: "/delivery-agents", component: DeliveryAgentsManagementlist, title: "User Management" },
  { path: "/delivery-agents-details", component: DeliveryAgentsDetails, title: "User Management" },

  // shop details 
  { path: "/shop-details", component: Shopdetails, title: "User Management" },
  // { path: "/user-order-details", component: UserManageOrderDetails },


  // admin profile
  { path: "/admin-profile", component: AdminProfileUpdate },

  // admin profile Setting
  { path: "/admin-setting", component: AdminSetting },

  // banner
  { path: "/banners", component: BannerManagementlist, title: "Banner Management" },
  { path: "/createBanner", component: CreateBanner, title: "Banner Management" },
  { path: "/updateBanner", component: UpdateBanner, title: "Banner Management" },

  // Category management
  { path: "/category-list", component: CategoryListManagement, title: "Category Management" },
  { path: "/createcategory", component: CreateCategory, title: "Category Management" },
  { path: "/updatecategory", component: UpdatedCategory, title: "Category Management" },
  //sub
  { path: "/sub-category-list", component: SubCategorylistManagement, title: "Category Management" },
  { path: "/create-sub-category", component: SubCategoryCreate, title: "Category Management" },
  { path: "/update-sub-category", component: SubSubCategoryUpdate, title: "Category Management" },

  // child Category
  { path: "/child-category-list", component: ChildCategoryManagement, title: "Category Management" },
  { path: "/create-child-category", component: ChildCategoryCreate, title: "Category Management" },
  { path: "/update-child-category", component: ChildCategoryUpdate, title: "Category Management" },

  // home block management
  { path: "/homeblock-list", component: HomeBlockManagementlist, title: "Block Management" },
  { path: "/createHomeblock", component: CreateHomeblock, title: "Block Management" },
  { path: "/updateHomeBlock", component: UpdateHomeBlock, title: "Block Management" },
  { path: "/home-block/size-list", component: SizeManagement, title: "Block Management" },
  { path: "/createSize", component: CreateSize, title: "Block Management" },
  { path: "/updateSize", component: UpdateSize, title: "Block Management" },
  { path: "/web-block-list", component: WebHomeBlockList, title: "Block Management" },
  { path: "/web-block-create", component: AddWebHomeblock, title: "Block Management" },
  { path: "/web-block-update", component: UpdateWebBlock, title: "Block Management" },
  { path: "/search-block-list", component: SearchHomeBlockList, title: "Block Management" },
  { path: "/create-search-block", component: CreateSearchBlock, title: "Block Management" },
  { path: "/update-search-block", component: UpdateSeachBlock, title: "Block Management" },

  //Product Management
  { path: "/productlist", component: ProductManagementlist, title: "Product Management" },
  { path: "/product-details/:id", component: ProductDetails, title: "Product Management" },

  ///cart Mangemenent
  { path: "/cart", component: CartManagement, title: "Product Management" },

  // FAQ Management
  { path: "/faq-management", component: FaqManagement, title: "FAQ Management" },
  { path: "/faq-create", component: FaqCreate },
  { path: "/faq-update", component: FaqUpdate },

  // Transactions Management
  { path: "/user-transactions", component: UserTransactions, title: "Transactions Overview" },
  { path: "/manufacturer-transactions", component: ManufacturerTransactions, title: "Transactions Overview" },
  { path: "/manufacturer-wallet-transactions", component: ManufacturerWalletTransactions, title: "Transactions Overview" },
  { path: "/agent-wallet-transactions", component: AgentWalletTransactions, title: "Transactions Overview" },
  { path: "/withdrawal-request", component: WithdrawalRequest, title: "Transactions Overview" },

  // Role Access
  { path: "/roles", component: RoleManagement },
  { path: "/createRole", component: RoleCreate },
  { path: "/updateRole", component: RoleUpdate },

  // Role Access
  { path: "/newsList", component: NewsLetterList },

  //Notification Management
  { path: "/notifications", component: NotificationManagement },
  { path: "/createNotification", component: NotificationCreate },
  { path: "/updateNotification", component: NotificationUpdate },

  // Support Management
  { path: "/support-list", component: SupportManagement, title: "Support Management" },
  { path: "/support-category-list", component: SupportListCategory, title: "Support Management" },
  { path: "/support-category-create", component: SupportCreateCategory, title: "Support Management" },
  { path: "/support-category-update", component: SupportCategoryUpdate, title: "Support Management" },
  { path: "/support-reply/:id", component: SupportTicketReplay, title: "Support Management" },

  ///inquiry managment
  { path: "/inquiry-list", component: InquiryList, title: "Inquiry Management" },
  { path: "/InuiryReplyViewMode/:id", component: InquiryReplyViewMode, title: "Inquiry Management" },

  // order management 
  { path: "/order-list", component: OrderManagementList, title: "Order Management" },
  { path: "/assign-orders", component: AssignOrderList, title: "Order Management" },
  { path: "/order-list", component: UserOrderDetails, title: "Order Management" },
  { path: "/order-sent-manufacturer", component: OrderSentManufacturer, title: "Order Management" },
  { path: "/order-sent-manufacturer/:id", component: ManufacturerOrderDetails, title: "Order Management" },
  { path: "/user-order-details/:id", component: UserManageOrderDetails, title: "Order Management" },
  { path: "/assign-confrim-delivery/:id", component: ConfirmOrderAssign, title: "Order Management" },
  { path: "/manufeaturer-assign-confrim-delivery/:id", component: ManufaturerConfirmOrderAssign, title: "Order Management" },


  // setting management 
  { path: "/settings", component: SettingManage, title: "Setting Management" },
  { path: "/instructions-setting", component: InstructionsSetting, title: "Setting Management" },

  // shop management 
  { path: "/shops", component: ShopList, title: "shops" },


  // Notification management 
  { path: "/notifications-details", component: NotificationsDetails, title: "Notifications Details" },

  // warehouse management 
  { path: "/warehouse-list", component: WarehouseManagementList, title: "Warehouse Management" },
  { path: "/warehouse-create", component: WarehouseManagementCreate, title: "Warehouse Management" },
  { path: "/warehouse-update/:id", component: WarehouseManagementUpdate, title: "Warehouse Management" },
  { path: "/warehouse-inventory/:id", component: WareHouseInventoryManage, title: "Warehouse Management" },

  // video management 

  // { path: "/videos", component: VideoManagementlist },
  // { path: "/createVideo", component: CreateVideo },
  // { path: "/video/update", component: UpdateVideo },
];

const authRoutes = [
  { path: "/login", component: Login },
  { path: "/PasswordReset", component: Forgetpassword },
];

const agentRoutes = [];

export { userRoutes, authRoutes, agentRoutes };
